const containerTransportGrid_filters = {
	"containerTransportGrid.filters.requiredByDate": "Requested Delivery Date"
};

export { containerTransportGrid_filters };
